import React, { useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { satc_pricePeriod } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useTranslation } from "react-i18next";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { getAccountingPricePeriod } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import AddPricePeriods from "./AddPricePeriods";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";

export default function Periods() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState();
  const [columns, setColumns] = useState([]);
  const { accountPricePeriod, getPricePeriodAgain, pagination } = useSelector(
    (state) => ({
      accountPricePeriod: state.saAccounts.accountPricePeriod,
      activePeriods: state.saAccounts.activePeriods,
      getPricePeriodAgain: state.saAccounts.getPricePeriodAgain,
      pagination: state.saAccounts.pagination,
    })
  );

  useEffect(() => {
    onEnter();
  }, []);

  const onEnter = async () => {
    setLoading(true);
    const _columns = [...satc_pricePeriod];
    _columns[6].hidden = !read("FormPeriod").accessUpdate;
    _columns[7].hidden = !read("FormPeriod").accessDelete;
    setColumns(_columns);
    await getPrices(1, sizePerPage);
  };

  const getPrices = async (_page, _sizePerPage) => {
    setLoading(true);
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: _sizePerPage,
        Page: _page,
      };
      await dispatch(getAccountingPricePeriod(params));
      setLoading(false);
      resolve(true);
    });
  };

  useEffect(() => {
    if (accountPricePeriod) {
      setTblData(accountPricePeriod);
      setSizePerPage(pagination.Limit);
      setCurrentPage(pagination.Page);
      setTotal(pagination.Total);
    }
  }, [accountPricePeriod]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await getPrices(page, sizePerPage);
    }
  };

  useEffect(() => {
    if (getPricePeriodAgain) {
      (async () => {
        await getPrices(currentPage, sizePerPage);
      })();
    }
  }, [getPricePeriodAgain]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id={"periods"} />} />
        <div className="top-buttons">
          <AddPricePeriods disabled={loading} />
        </div>
      </div>
      <MuiPaper>
        {columns && columns.length !== 0 && (
          <RemoteTable
            data={tblData}
            columns={columns}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        )}
      </MuiPaper>
    </>
  );
}
